export function formatFileName(name: string, maxLength = 20) {
  if (name.length <= maxLength) return name;

  const ext = name.split('.').pop();
  const base = name.substring(0, name.lastIndexOf('.'));

  const start = base.substring(0, maxLength - 8);
  const end = base.substring(base.length - 5);

  return `${start}...${end}.${ext}`;
}
